import { useContext, useEffect, useState } from "react";
import { IBackground } from "../../Styles/IStyled";
import {
  BackGroundModal,
  ButtonBackModal,
  ButtonRemoveProdModal,
  Div,
  IconChevronLeft,
  IconFaCart,
  Input,
} from "../../Styles/Styled";
import { GestorContext } from "../../store/GestorStore";
import {
  FaTrashAlt,
  FaCaretDown,
  FaCaretUp,
  FaMinus,
  FaPlus,
} from "react-icons/fa";
import RenderListAdicionais from "../ListAdicionais";
import { Colors, FATIA_PIZZA, RECEITA_CHEIA } from "../../config";

interface IProductsModal extends IBackground {
  id?: number;
  chave: number;
  descricao: string;
  preco_venda: number;
  grupo1: string;
  grupo2: string;
  grupo3: string;
  tipo: string;
  onPressClose: Function;
  kits?: any;
  extras?: IExtraProd[];
  picture: string;
  quantidade?: number;
  observacao?: string;
}

interface IExtraProd {
  chave: number;
  descricao: string;
  ordem: number;
  quantidade: number;
  qme: number;
  preco_venda: number;
  chave_kit: number;
}

export default function ModalProduto(props: IProductsModal) {
  const [observations, setObservations] = useState("");
  const [extras, setExtras] = useState<IExtraProd[]>([]);
  const [openExtras, setOpenExtras] = useState<boolean>(true);
  const [quantidade_sabores, setQuantidadeSabores] = useState(1);
  const [quantidade_maxima, setQuantidadeMaxima] = useState(99);

  const [fixed, setFixed] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const Gestor = useContext(GestorContext);
  const width = window.innerWidth * 0.9 > 15000 ? 500 : window.innerWidth;
  const height =
    window.innerWidth * 0.9 > 15000
      ? window.innerHeight * 0.68
      : window.innerHeight;

  const tamanho_footer = height * 0.1;
  const tamanho_filhos = tamanho_footer * 0.65;

  const SumButton = () => {
    if (quantity >= 99) return;
    setQuantity(quantity + 1);
  };

  const MinusButton = () => {
    if (quantity <= 1) return;
    setQuantity(quantity - 1);
  };

  const SumButtonPizza = () => {
    if (quantidade_sabores >= quantidade_maxima) return;
    setExtras([]);
    setQuantidadeSabores(quantidade_sabores + 1);
  };

  const MinusButtonPizza = () => {
    if (quantidade_sabores <= 1) return;
    setExtras([]);
    setQuantidadeSabores(quantidade_sabores - 1);
  };

  function findOffset(element: any) {
    var top = 0,
      left = 0;
    do {
      top += element.offsetTop || 0;
      left += element.offsetLeft || 0;
      element = element.offsetParent;
    } while (element);
    return {
      top: top,
      left: left,
    };
  }

  interface IProdKit {
    chave: number;
    descricao: string;
    preco_venda: string;
    qme: number;
  }

  const FooterPrice = () => {
    const valor_extras = extras
      .filter((e) => e.ordem == 99)
      .reduce((a: number, b) => {
        return a + b?.preco_venda * b?.quantidade;
      }, 0);
    const preco =
      (parseFloat(`${props.preco_venda}`) + valor_extras) * quantity;
    const valor = new Intl.NumberFormat("pt-BR", {
      minimumFractionDigits: 2,
    }).format(preco);

    return (
      <div
        id="footer22"
        style={{
          height: tamanho_footer,
          backgroundColor: Colors.modalBackgroundColor,
          width: "100%",
          position: "fixed",
          bottom: 0,
          borderTop: `1px solid ${Colors.modalDetailColor}`,
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
          flexDirection: "row",
        }}
      >
        <div
          style={{
            height: tamanho_filhos - 2,
            width: "30%",
            border: `1px solid  ${Colors.modalDetailColor}`,
            borderRadius: 5,
            display: "flex",
            flexDirection: "row",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "40%",
            }}
            onClick={() => MinusButton()}
          >
            <FaMinus size={12} color={Colors.listGroupTitleColor} />
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "20%",
              color: Colors.listGroupTitleColor,
            }}
          >
            {quantity}
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "40%",
            }}
            onClick={() => SumButton()}
          >
            <FaPlus size={12} color={Colors.listGroupTitleColor} />
          </div>
        </div>

        <div
          id="butao_adicionar"
          onClick={() => (props?.quantidade ? AttProd() : addProd())}
          style={{
            height: tamanho_filhos,
            width: "60%",
            display: "flex",
            backgroundColor: Colors.modalBackgroundColor,
            border: `1px solid  ${Colors.modalDetailColor}`,
            justifyContent: "space-around",
            alignItems: "center",
            flexDirection: "row",
            borderRadius: 5,
            cursor: "pointer",
            fontSize: 14,
          }}
        >
          <span>{props.quantidade ? "Atualizar" : "Adicionar"}</span>

          <span style={{ fontWeight: "bold" }}>R$ {valor}</span>
        </div>
      </div>
    );
  };

  const plusAdicional = (prod: IProdKit, ordem: number, chave_kit: number) => {
    const prod_extras = extras;
    const quantidade_kit =
      prod_extras
        ?.filter((e) => e?.chave_kit === chave_kit)
        ?.reduce((a, b) => {
          return a + b.quantidade;
        }, 0) || 0;
    const prod_origem = props?.kits
      ?.find((e: any) => e?.chave === chave_kit)
      ?.grupo_kit?.produtosnv1?.find((e: any) => e?.chave === prod?.chave);

    if (prod_extras?.filter((e) => e?.chave === prod?.chave)[0]) {
      if (FATIA_PIZZA) {
        const prod2 = prod_extras?.filter((e) => e?.chave === prod?.chave)[0];
        if (quantidade_kit < quantidade_maxima) {
          if (prod2.quantidade < quantidade_sabores) {
            prod2.quantidade = prod2.quantidade + 1;
            const new_quantidade = quantidade_sabores + 1;
            setQuantidadeSabores(new_quantidade);
          } else if (quantidade_sabores < quantidade_maxima) {
            const new_quantidade = quantidade_sabores + 1;
            prod2.preco_venda =
              parseFloat(prod_origem?.preco_venda) *
                (quantidade_maxima / new_quantidade) || prod2?.preco_venda;
            prod2.quantidade = prod2.quantidade + 1;
            setQuantidadeSabores(new_quantidade);
          }
        } else {
          if (quantidade_sabores < quantidade_maxima) {
            const new_quantidade = quantidade_sabores + 1;
            prod2.quantidade = prod2.quantidade + 1;
            prod2.preco_venda =
              parseFloat(prod_origem?.preco_venda) *
                (quantidade_maxima / new_quantidade) || prod2?.preco_venda;
            setQuantidadeSabores(new_quantidade);
          }
        }
        const new_prod = prod_extras?.filter((e) => e?.chave !== prod?.chave);
        setExtras([...new_prod, prod2]);
        return;
      } else {
        //remove produto caso exista
        const prod2 = prod_extras?.filter((e) => e?.chave === prod?.chave)[0];
        if (prod2) {
          prod2.quantidade = prod2.quantidade + 1;
        }
        const new_prod = prod_extras?.filter((e) => e?.chave !== prod?.chave);
        setExtras([...new_prod, prod2]);
        return;
      }
    }

    let valor = parseFloat(prod?.preco_venda);
    if (FATIA_PIZZA) {
      if (quantidade_kit === 0) {
        const valor =
          parseFloat(prod?.preco_venda) *
          (quantidade_maxima / quantidade_sabores);
        prod_extras.push({
          ...prod,
          preco_venda: valor,
          ordem: ordem,
          chave_kit: chave_kit,
          quantidade: 1,
          qme: parseFloat(`${prod.qme}`),
        });
        setExtras([...prod_extras]);
        return;
      }
      if (quantidade_kit < quantidade_sabores) {
        prod_extras.push({
          ...prod,
          preco_venda: valor,
          ordem: ordem,
          chave_kit: chave_kit,
          quantidade: 1,
          qme: parseFloat(`${prod.qme}`),
        });
        setExtras([...prod_extras]);
        return;
      } else {
        if (quantidade_sabores < quantidade_maxima) {
          prod_extras.push({
            ...prod,
            preco_venda: valor,
            ordem: ordem,
            chave_kit: chave_kit,
            quantidade: 1,
            qme: parseFloat(`${prod.qme}`),
          });
          setExtras([...prod_extras]);
          setQuantidadeSabores(quantidade_sabores + 1);
          return;
        }
      }
      return;
    } else {
      prod_extras.push({
        ...prod,
        preco_venda: valor,
        ordem: ordem,
        chave_kit: chave_kit,
        quantidade: 1,
        qme: parseFloat(`${prod.qme}`),
      });
      setExtras([...prod_extras]);
      return;
    }
  };

  const minusAdicional = (prod: IProdKit, ordem: number, chave_kit: number) => {
    const prod_extras = extras;
    if (prod_extras?.filter((e) => e?.chave === prod?.chave)[0]) {
      //remove produto caso exista
      const prod2 = prod_extras?.filter((e) => e?.chave === prod?.chave)[0];
      if (prod2) {
        prod2.quantidade = prod2.quantidade - 1;
      }
      if (prod2.quantidade <= 0) {
        const new_prod = prod_extras?.filter((e) => e?.chave !== prod?.chave);
        if (quantidade_sabores > 1) {
          setQuantidadeSabores(quantidade_sabores - 1);
        }
        setExtras([...new_prod]);
        return;
      }
      if (quantidade_sabores > 1) {
        setQuantidadeSabores(quantidade_sabores - 1);
      }
      const new_prod = prod_extras?.filter((e) => e?.chave !== prod?.chave);
      setExtras([...new_prod, prod2]);
      return;
    }
    return;
  };

  const handleAddandRemoveProd = (
    prod: IProdKit,
    ordem: number,
    chave_kit: number
  ) => {
    const prod_extras = extras;
    if (prod_extras?.filter((e) => e?.chave === prod?.chave)[0]) {
      //remove produto caso exista
      const new_prod = prod_extras?.filter((e) => e?.chave !== prod?.chave);
      setExtras([...new_prod]);
      return;
    }
    if (prod_extras?.filter((e) => e?.chave_kit === chave_kit)[0]) {
      const new_prod = prod_extras?.filter((e) => e?.chave_kit !== chave_kit);
      new_prod.push({
        ...prod,
        preco_venda: parseFloat(prod?.preco_venda),
        ordem: ordem,
        chave_kit: chave_kit,
        quantidade: 1,
      });
      setExtras([...new_prod]);
      return;
    }
    prod_extras.push({
      ...prod,
      preco_venda: parseFloat(prod?.preco_venda),
      ordem: ordem,
      chave_kit: chave_kit,
      quantidade: 1,
      qme: parseFloat(`${prod.qme}`),
    });
    setExtras([...prod_extras]);
    return;
  };

  const addProd = () => {
    if (RECEITA_CHEIA && props.tipo === "R") {
      const quantidade_kit =
        extras?.reduce((a, b) => {
          return a + b.quantidade;
        }, 0) || 0;

      if (quantidade_kit !== quantidade_sabores) {
        return alert(
          "Pizza precisa que quantidade total de sabores seja escolhida!"
        );
      }
    }
    console.log(props);
    const obrigatorios = props?.kits
      ?.filter((e: any) => e?.obg === 1)
      ?.map((e: any) => e?.chave);

    if (obrigatorios[0] && props?.tipo === "R") {
      console.log(obrigatorios);
      let teste = false;

      extras?.map((e) => {
        if (obrigatorios.includes(e?.chave_kit)) {
          teste = true;
        }
        return;
      });

      if (teste === false) {
        alert("Pedido inclui itens obrigatorio, por favor selecione eles.");
        return;
      }
    }

    if (Gestor) {
      Gestor.addProd({
        ...props,
        id: Math.ceil(Math.random() * 10000000),
        kits: props?.kits,
        extras: extras,
        quantidade: quantity,
        observacao: observations,
        preco_venda: parseFloat(`${props.preco_venda}`),
      });
      props.onPressClose();
    }
  };

  const AttProd = () => {
    if (RECEITA_CHEIA && props.tipo === "R") {
      const quantidade_kit =
        extras?.reduce((a, b) => {
          return a + b.quantidade;
        }, 0) || 0;

      if (quantidade_kit !== quantidade_sabores) {
        return alert(
          "Pizza precisa que quantidade total de sabores seja escolhida!"
        );
      }
    }

    const obrigatorios = props?.kits
      ?.filter((e: any) => e?.obg === 1)
      ?.map((e: any) => e?.chave);

    if (obrigatorios[0] && props?.tipo === "R") {
      console.log(obrigatorios);
      let teste = false;

      extras?.map((e) => {
        if (obrigatorios.includes(e?.chave_kit)) {
          teste = true;
        }
        return;
      });

      if (teste === false) {
        alert("Pedido inclui itens obrigatorio, por favor selecione eles.");
        return;
      }
    }
    if (Gestor) {
      Gestor.attProd({
        ...props,
        kits: props?.kits,
        extras: extras,
        quantidade: quantity,
        observacao: observations,
        preco_venda: parseFloat(`${props.preco_venda}`),
      });
      props.onPressClose();
    }
  };

  const removeProd = () => {
    if (Gestor) {
      console.log(props);
      Gestor.removeProd(props?.id);
      props.onPressClose();
    }
  };

  useEffect(() => {
    const scroll = document.getElementById("modalProd") as any;
    document.body.style.overflow = "hidden";
    setQuantidadeMaxima(props?.kits[0]?.grupo_kit?.produtosnv1[0]?.qme || 99);
    setQuantidadeSabores(1);
    if (props.quantidade) {
      setQuantity(props.quantidade);
      setObservations(props?.observacao || "");
      setExtras(props?.extras || []);
    }
    const FixHeader = (element: Element) => {
      const stickyHeader = document.getElementById("containerList0");
      if (!stickyHeader) return;
      const headerOffset = findOffset(stickyHeader);
      const bodyScrollTop = element.scrollTop;
      if (bodyScrollTop > headerOffset.top) {
        setFixed(true);
      } else {
        setFixed(false);
      }
    };
    if (scroll) {
      scroll.addEventListener("scroll", () => FixHeader(scroll));
    }
    return () => {
      scroll.removeEventListener("scroll", () => FixHeader(scroll));
      document.body.style.overflow = "scroll";
    };
  }, []);

  useEffect(() => {
    if (FATIA_PIZZA) {
    }
    console.log(extras);
  }, [extras]);

  useEffect(() => {
    if (FATIA_PIZZA) {
      const new_extras = extras.map((e) => {
        const prod_origem = props?.kits
          ?.find((f: any) => f?.chave === e?.chave_kit)
          ?.grupo_kit?.produtosnv1?.find((f: any) => f?.chave === e?.chave);
        console.log(prod_origem, "original");
        e.preco_venda =
          parseFloat(prod_origem?.preco_venda) *
            (quantidade_maxima / quantidade_sabores) || e?.preco_venda;
        return e;
      });
      setExtras(new_extras);
    }
  }, [quantidade_sabores]);

  return (
    <BackGroundModal Content="none" open={props.open}>
      <Div
        id="modalProd"
        Width={`${width}px`}
        style={{
          overflowX: "hidden",
        }}
        Height={`${height * 0.9}px`}
        Items="center"
        border={
          window.innerWidth * 0.9 > 15000
            ? { bottom: `1px solid ${Colors.modalBackgroundColor}` }
            : {}
        }
        background={Colors.modalBackgroundColor}
        borderRadius={
          window.innerWidth * 0.9 > 15000
            ? {
                top: {
                  left: "15px",
                  right: "15px",
                },
                bottom: {
                  left: "15px",
                  right: "15px",
                },
              }
            : {}
        }
      >
        {fixed && (
          <div
            style={{
              height: 60,
              width: "100%",
              backgroundColor: Colors.modalBackgroundColor,
              position: "fixed",
              borderBottom: `1px solid ${Colors.listGroupBorderColor} `,
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <ButtonBackModal
              style={{
                top: 10,
                borderColor: Colors.modalTitleColor,
              }}
              onClick={() => {
                props.onPressClose();
              }}
            >
              {" "}
              <IconChevronLeft color={Colors.modalTitleColor} size={20} />{" "}
            </ButtonBackModal>

            <span>{props.descricao}</span>

            {props.quantidade && (
              <ButtonRemoveProdModal
                style={{
                  top: 10,
                  borderColor: Colors.modalTitleColor,
                }}
                onClick={() => {
                  removeProd();
                }}
              >
                <FaTrashAlt style={{ color: Colors.modalTitleColor }} />
              </ButtonRemoveProdModal>
            )}
          </div>
        )}

        <ButtonBackModal
          style={{
            color: Colors.modalTitleColor,
            borderColor: Colors.modalTitleColor,
          }}
          onClick={() => {
            props.onPressClose();
          }}
        >
          <IconChevronLeft color={Colors.modalTitleColor} size={20} />
        </ButtonBackModal>

        {props.quantidade && (
          <ButtonRemoveProdModal
            style={{
              color: Colors.modalTitleColor,
              borderColor: Colors.modalTitleColor,
            }}
            onClick={() => {
              removeProd();
            }}
          >
            <FaTrashAlt color={Colors.modalTitleColor} />
          </ButtonRemoveProdModal>
        )}
        <div
          style={{
            height:
              window.innerWidth * 0.9 > 500 ? height * 0.4 : height * 0.25,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: width,
              height:
                window.innerWidth * 0.9 > 500 ? height * 0.3 : height * 0.2,
              objectFit: "contain",
              marginTop: 20,
              marginBottom: 0,
              borderRadius: 0,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <img
              style={{
                width: "auto",
                height:
                  window.innerWidth * 0.9 > 500 ? height * 0.3 : height * 0.2,
                objectFit: "contain",
                borderRadius: 5,
              }}
              onError={(e: any) => (e.target.src = "./notfound.png")}
              src={props.picture}
            />
          </div>
        </div>

        <Div
          Text={`${props.descricao}`}
          Height={`${height * 0.07}px`}
          Content="center"
          Items="center"
          TextAlign="center"
          TextColor={Colors.modalTitleColor}
          Width={"100%"}
          TextSize="0.90em"
        />

        {props?.observacao && (
          <Div
            Text={`${props?.observacao || ""}`}
            Height={`${height * 0.085}px`}
            Content="center"
            Items="center"
            TextColor={Colors.modalObsColor}
            Width={"92%"}
            TextSize="0.85em"
            TextAlign="center"
          />
        )}

        {props?.descricao?.toUpperCase()?.includes("PIZZA") && FATIA_PIZZA && (
          <div
            id="footer22"
            style={{
              height: tamanho_footer,
              backgroundColor: Colors.modalBackgroundColor,
              width: "100%",
              display: "flex",
              justifyContent: "space-around",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <span style={{ color: Colors.modalDetailColor }}>
              Quantidade De Sabores max({quantidade_maxima})
            </span>
            {false && (
              <div
                style={{
                  height: tamanho_filhos - 10,
                  width: "30%",
                  border: `1px solid  ${Colors.modalDetailColor}`,
                  borderRadius: 5,
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "40%",
                  }}
                  onClick={() => MinusButtonPizza()}
                >
                  <FaMinus size={12} color={Colors.listGroupTitleColor} />
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "20%",
                    color: Colors.listGroupTitleColor,
                  }}
                >
                  {quantidade_sabores}
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "40%",
                  }}
                  onClick={() => SumButtonPizza()}
                >
                  <FaPlus size={12} color={Colors.listGroupTitleColor} />
                </div>
              </div>
            )}
          </div>
        )}

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
          }}
        >
          {openExtras && props.tipo === "R" && (
            <div
              id="lista_adicionais"
              style={{
                display: "flex",
                width: "100%",
                flexDirection: "column",
              }}
            >
              {props?.kits?.length > 0 &&
                props.kits?.map((e: any, index: number) => (
                  <RenderListAdicionais
                    {...e}
                    quantidadeSabores={quantidade_sabores}
                    quantidadeMaxima={quantidade_maxima}
                    index={index}
                    sabores_quantidade
                    extras={extras}
                    onAdd={(a: any, b: any, c: any) => {
                      handleAddandRemoveProd(a, b, c);
                    }}
                    onPlus={(a: any, b: any, c: any) => {
                      plusAdicional(a, b, c);
                    }}
                    onMinus={(a: any, b: any, c: any) => {
                      minusAdicional(a, b, c);
                    }}
                  />
                ))}
            </div>
          )}
        </div>

        <div
          style={{
            width: "100%",
            fontSize: "18px",
            paddingLeft: 10,
            height: height * 0.05,
            marginTop: "auto",
            marginBottom: 15,
            color: "#FFF",
          }}
        >
          Observacoes:
        </div>

        <textarea
          placeholder="Sem ovo, maionese, mal passado, bem passado..."
          style={{
            minHeight: height * 0.12,
            paddingLeft: 5,
            paddingRight: 5,
            paddingTop: 5,
            paddingBottom: 5,
            borderWidth: 2,
            fontSize: 15,
            borderColor: Colors.modalDetailColor,
            marginBottom: "10px",
            borderStyle: "solid",
            width: width - 20,
            color: Colors.modalTitleColor,
          }}
          value={observations}
          onChange={(e) => setObservations(e.currentTarget.value)}
        />

        {FooterPrice()}
      </Div>
    </BackGroundModal>
  );
}
